import { render, staticRenderFns } from "./SatDeviceTab.vue?vue&type=template&id=7adf5910&scoped=true&"
import script from "./SatDeviceTab.vue?vue&type=script&lang=js&"
export * from "./SatDeviceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adf5910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adf5910')) {
      api.createRecord('7adf5910', component.options)
    } else {
      api.reload('7adf5910', component.options)
    }
    module.hot.accept("./SatDeviceTab.vue?vue&type=template&id=7adf5910&scoped=true&", function () {
      api.rerender('7adf5910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/components/SatDeviceTab.vue"
export default component.exports